import React from 'react';
import { Link } from 'react-router-dom';
import facebookIcon from '../assets/images/facebookIcon.png';
import instagramIcon from '../assets/images/instagramIcon.png';
import youtubeIcon from '../assets/images/youtubeIcon.png';
import { useSelector } from 'react-redux';
import { langSelector } from '../store/langSlice';
import { getLang } from '../environnement';

function FooterItem({
  item,
  link,
  lang
}) {
  return (
    <Link className='text-white font-medium text-xl xxs:text-2xl text-center lg:text-start hover:underline hover:decoration-solid my-2 lg:w-[250px]' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}} to={link}>{item}</Link>
  );
}

export default function Footer() {
  const lang = useSelector(langSelector);

  const leftItems = [
    {id: 1, title: getLang(lang).footer.aProposDuCentre, link: '/apropos-centre'},
    // {id: 2, title: getLang(lang).footer.reserverSalle, link: '/demande-salle'},
    // {id: 3, title: getLang(lang).footer.consulterEtatDemande, link: '/suivre-demande-login'},
  ];

  return (
    <div className='bg-secondary px-10 py-5 flex justify-center' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none'}}>
      <div className='w-[1200px] flex flex-col items-center lg:items-start lg:flex-row lg:justify-around'>
        <div className='flex flex-col lg:pl-15 lg:w-[520px] xl:w-[600px]'>
          {leftItems.map((item) => {
            return (<FooterItem lang={lang} key={item.id} item={item.title} link={item.link} />)
          })}
        </div>
        <div className='flex flex-col lg:w-[350px] xl:w-[450px]'>
          <FooterItem lang={lang} item={getLang(lang).footer.nousContacter} link='/nous-contacter' />
          <div className='flex pt-2 ml-4 lg:ml-0 justify-center lg:justify-start' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>
            <Link to='#' className={`${lang === 'ar' ? 'ml-5' : 'mr-5'} hover:relative hover:bottom-1`}>
              <img src={facebookIcon} alt='facebook' />
            </Link>
            <Link to='#' className={`${lang === 'ar' ? 'ml-5' : 'mr-5'} hover:relative hover:bottom-1`}>
              <img src={instagramIcon} alt='instagram' />
            </Link>
            <Link to='#' className={`${lang === 'ar' ? 'ml-5' : 'mr-5'} hover:relative hover:bottom-1`}>
              <img src={youtubeIcon} alt='youtube' />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
